import { CdkScrollableModule, ScrollingModule } from '@angular/cdk/scrolling';
import { NgClass } from '@angular/common';
import { Component, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-search-panel',
  standalone: true,
  imports: [TranslateModule, NgClass, CdkScrollableModule, ScrollingModule],
  templateUrl: './search-panel.component.html',
  styleUrls: ['./search-panel.component.scss'],
})
export class SearchPanelComponent {
  showLeftPanel = model(true);

  toggleLeftPanel() {
    this.showLeftPanel.update((val) => !val);
  }
}
